import axios from "axios";

const ADBOX_API_URL = process.env.VUE_APP_ADBOX_API_URL;

export default {
  namespaced: true,
  state: {
    articles: [],
    currentArticle: null,
    currentTitleArticle: null,
    categories:[],
  },
  mutations: {
    SET_ARTICLES(state, value) {
      state.articles = value;
    },
    SET_CURRENT_ARTICLE(state, value) {
      state.currentArticle = value;
    },
    SET_CATEGORIES(state, value) {
      state.categories = value;
    }
  },
  actions: {
    async GET_ARTICLES({ rootState, commit }) {
      try {
        const { data } = await axios({
          method: "GET",
          url: `${ADBOX_API_URL}/articles`,
          headers: {
            Authorization: rootState.token,
          },
        });
        
        commit("SET_ARTICLES", data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_ARTICLE_BY_ID({ rootState, commit }, { id }) {
      try {
        const { data } = await axios({
          method: "GET",
          url: `${ADBOX_API_URL}/articles/${id}`,
          headers: {
            Authorization: rootState.token,
          },
        });
        
        commit("SET_CURRENT_ARTICLE", data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async CREATE_POST({ rootState }, { id, bodyPost, titlePost }){
      try{
        
        const slug                     = titlePost.replace(/ /g, "-");
        const getfirtsTagOpenElementP  = bodyPost.indexOf("<p>");
        const getfirtsTagCloseElementP = bodyPost.indexOf("</p>");
        const description              = bodyPost.substr((getfirtsTagOpenElementP + 3), (getfirtsTagCloseElementP - 4));
                
        const { data } = await axios({
          method: "POST",
          url: `${ADBOX_API_URL}/articles`,
          data: {
            title: titlePost,
            content: bodyPost,
            user_id: id,
            slug,
            description,
            isVisible: false
          },
          headers: {
            Authorization: rootState.token,
          },
        });
        return { success: true, data: data.data };
      }catch(error){
        return { success: false, data: error};
      }
    },
    async DELETE_ARTICLE({ rootState }, { id }){
      try{        
        const { data } = await axios({
          method: "DELETE",
          url: `${ADBOX_API_URL}/article/${id}`,
          headers: {
            Authorization: rootState.token,
          },
        });
        return { success: true, data: data.data };
      }catch(error){
        return { success: false, data: error};
      }
    },
    async UPDATE_ARTICLE({ rootState }, { new_data }){
      try{
        
        const slug                     = new_data.title_post.replace(/ /g, "-");
        const getfirtsTagOpenElementP  = new_data.body_post.indexOf("<p>");
        const getfirtsTagCloseElementP = new_data.body_post.indexOf("</p>");
        const description              = new_data.body_post.substr((getfirtsTagOpenElementP + 3), (getfirtsTagCloseElementP - 4));
              
        const { data } = await axios({
          method: "PUT",
          url: `${ADBOX_API_URL}/article/${new_data.id}`,
          data: {
            title: new_data.title_post,
            content: new_data.body_post,
            slug,
            description
          },
          headers: {
            Authorization: rootState.token,
          },
        });
        return { success: true, data: data.data }; 
      }catch(error){
        return { success: false, data: error};
      }
    },
    async SET_VISIBLE_ARTICLE_BY_ID({ rootState }, { id, value }){
      try {
        const {} = await axios({
          method: "PUT",
          url: `${ADBOX_API_URL}/articles/${id}/visible`,
          data: {
            is_visible: value
          },
          headers: {
            Authorization: rootState.token,
          },
        });

      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async GET_CATEGORIES({ rootState, commit }){
      try {
        const { data } = await axios({
          method: "GET",
          url: `${ADBOX_API_URL}/categories`,
          headers: {
            Authorization: rootState.token,
          },
        });
        
        commit("SET_CATEGORIES", data.data);
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },
    async CREATE_CATEGORY({ rootState }, { category }){
      try {
        const { data } = await axios({
          method: "POST",
          url: `${ADBOX_API_URL}/category`,
          data:{
            title: category,
            order:1
          },
          headers: {
            Authorization: rootState.token,
          },
        });
        
        return { success: true, data: data.data };
      } catch (error) {
        return { success: false, data: error.response };
      }
    },

  },
};
